import {useEffect, useState} from 'react';

const secondsLeft = (expiresAt) =>
  Math.max(0, Math.ceil((new Date(expiresAt).getTime() - Date.now()) / 1000));

const useCountdown = (expiresAt) => {
  const [seconds, setSeconds] = useState(() =>
    expiresAt ? secondsLeft(expiresAt) : 0
  );

  useEffect(() => {
    if (!expiresAt) return undefined;

    setSeconds(secondsLeft(expiresAt));
    const interval = setInterval(() => {
      const left = secondsLeft(expiresAt);
      setSeconds(left);
      if (!left) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  return {
    seconds,
    label: `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(
      2,
      '0'
    )}`
  };
};

export default useCountdown;
